import * as c from '../constants/auth';
import {
  APP_GET_APPLIST,
  APP_GET_APPLIST_FAILURE,
  APP_GET_APPLIST_SUCCESS,
} from '../constants/app';
import { init, setAppInfo, setLoading, getAppList, reset } from './app';
import { modal, dismiss } from './notification';
import { apiAction, quitGdlAction } from './api';
import history from '../utils/history';

export const setAuthenticated = (authenticated) => ({
  type: c.AUTH_SET_AUTHENTICATED,
  authenticated: authenticated === true,
});

export const setStudentInfo = (info, studentIdNumber) => ({
  type: c.AUTH_SET_STUDENT_INFO,
  studentIdNumber: studentIdNumber,
  studentId: info.studentId,
  groupId: info.groupId,
  groupName: info.name,
  alias: info.alias || info.studentId,
  isTeacher: info.belongsToTeacher,
});

export const initializeAuth = () => async (dispatch, getState) => {
  const isAuthenticated = window.sessionStorage.getItem('token') !== null;
  const queryname = window.location.pathname.match(/\/app\/(.+)/);
  if (isAuthenticated) {
    // startup, get app list and attempt to get app code from url pathname
    dispatch(getAppList());
    if (queryname !== null && queryname.length > 1) {
      // set the app code and initialize if exists
      dispatch(setAppInfo(queryname[1]));
      dispatch(init());
    }
    dispatch(setAuthenticated(true));
  } else {
    // dispatch whoami action
    try {
      const response = await dispatch(
        apiAction(
          [c.AUTH_WHOAMI, c.AUTH_WHOAMI_SUCCESS, c.AUTH_WHOAMI_FAILURE],
          (api) => api.whoami()
        )
      );
      if (response.groupId && response.studentId) {
        await dispatch(login(response.studentId, response.groupId));
        if (queryname !== null && queryname.length > 1) {
          // set the app code and initialize
          dispatch(getAppList());
          dispatch(setAppInfo(queryname[1]));
          dispatch(init());
        }
      } else {
        // not authenticated, remove loading overlay so login form is displayed
        dispatch(setLoading(false));
        dispatch(setAuthenticated(false));
      }
    } catch (e) {
      dispatch(setLoading(false));
      dispatch(setAuthenticated(false));
    }
  }
};

export const login = (studentId, groupId) => async (dispatch, getState) => {
  const response = await dispatch(
    apiAction(
      [c.AUTH_LOGIN_START, c.AUTH_LOGIN_SUCCESS, c.AUTH_LOGIN_FAILURE],
      (api) => api.login(studentId, groupId)
    )
  );
  window.sessionStorage.setItem('token', response.token);

  dispatch(getAppList());
  dispatch(init());
};

export const confirmLogout = () => (dispatch) => {
  const buttons = [
    {
      label: 'Cancel',
      variant: 'light',
      action: (id) => dispatch(dismiss(id)),
    },
    {
      label: 'Sign Out',
      variant: 'primary',
      action: (id) => {
        dispatch(dismiss(id));
        dispatch(logout());
      },
    },
  ];

  dispatch(
    modal(
      'Sign Out',
      'Are you sure you want to sign out?  Any unsaved changes will be lost.',
      buttons,
      { backdrop: true }
    )
  );
};

export const logout = () => (dispatch) => {
  Promise.all([
    dispatch(quitGdlAction()),
    dispatch(reset(true)),
    dispatch(
      apiAction(
        [c.AUTH_LOGOUT_START, c.AUTH_LOGOUT_SUCCESS, c.AUTH_LOGOUT_FAILURE],
        (api) => api.logout()
      )
    ),
  ]).then(() => {
    history.push('/');
  });
};
